import {
    Locale,
    GameName,
    DefaultLocale,
    gameSettings,
} from "inbox-contentful";

const gameName: GameName = "rogue";

export const config = {
    gameName,
    gameResolution: {
        x: 740,
        y: 480,
    },
    locales: (gameSettings[gameName]?.enabledLocales ?? [
        DefaultLocale,
    ]) as Locale[],
    tabs: ["news"],
    isFullScreen: false,
};
